<div *ngIf="dividerKind!==-1" class="row" [ngClass]="{'m-1': dividerKind===1, 'm-2': dividerKind===2, 'm-3': dividerKind===3}">
  <div class="col">
    <hr *ngIf="dividerKind===0">
  </div>
</div>
